/* Aleph Male: customer photo collage, fed by the Covet.pics gallery. Stays hidden if the gallery can't be loaded. */
(function () {
  var root = document.querySelector('[data-am-collage]');
  if (!root || !window.fetch) return;
  var grid = root.querySelector('.am-collage__grid');
  var base = 'https://app.covet.pics/api/v1/embed/' + root.getAttribute('data-gallery');
  var MAX = 24;
  var BIG = { 0: 1, 7: 1, 12: 1, 19: 1 };

  function get(url) { return fetch(url).then(function (r) { return r.json(); }); }

  get(base).then(function (first) {
    var items = first.items || [];
    if ((first.total_pages || 1) > 1 && items.length < MAX) {
      return get(base + '?page=2').then(function (second) { return items.concat(second.items || []); }, function () { return items; });
    }
    return items;
  }).then(function (items) {
    var photos = items.filter(function (it) { return it && it.data_type === 'image' && it.images && it.images.medium_resolution; }).slice(0, MAX);
    if (photos.length < 6) return;
    photos.forEach(function (it, i) {
      var tile = document.createElement('div');
      tile.className = 'am-collage__tile' + (BIG[i] ? ' am-collage__tile--big' : '');
      var img = document.createElement('img');
      img.src = BIG[i] && it.images.high_resolution ? it.images.high_resolution : it.images.medium_resolution;
      img.alt = it.alt_tag || it.images.alt_tag || 'Aleph Male customer photo';
      img.loading = 'lazy';
      tile.appendChild(img);
      grid.appendChild(tile);
    });
    root.hidden = false;
  }).catch(function () {});
})();
